export default [
  {
    title: 'Accueil',
    route: 'home',
    icon: 'HomeIcon'
  }
]
